import axios from "axios";
import Modal from "component/Common/LoaderModal";
import { history } from "helpers";
import { getbaseUrl } from "./baserul";
import endpoints from "./endpoints";
import { Toast } from "./toast";


export const request = ({
  url = "",
  method = endpoints.APIMethods.GET,
  data,
  isLoader = true,
  baseUrl = "user",
  responseType,
  token = localStorage.getItem("token"),

  params,
  contentType,
  errorToast = true,
  successToast = true,
  statusCode = true,
  successMsg
}) =>
  
  new Promise((resolve, reject) => {
  
    let config = {
      url: getbaseUrl(baseUrl) + url,
      method: method,
      params: params ? params : null,
      data: data ? data : null,
      responseType: responseType ? responseType : null,
      headers: {
        Authorization: token ? "Bearer " + token : "" ,
        "Content-Type": contentType || "application/json",
      },
    };
    config.params == null && delete config.params;
    config.data == null && delete config.data;
    config.responseType == null && delete config.responseType;

    showLoader(isLoader);

    axios(config)
      .then((response) => {
        let {
          data: { message },
        } = response;
        showLoader(false);
        method !== "GET" && (successToast && Toast({ type: "success", message: successMsg || message }));
        return resolve(response);
      })
      .catch(({ response }) => {
        showLoader(false);
        if (response) {
          let {
            status,
            data: { message } = {message: ''},
          } = response;
          if (status === 401) {
            localStorage.clear("token")
            return history.replace("/login");
          }
          errorToast && Toast({ type: "error", message: message ? message : "Not able to connect the server. Please try again later" });
        } else {
          Toast({
            type: "error",
            message: "Not able to connect the server. Please try again later",
          });
        }

        return reject(response);
      });
  });

const showLoader = (status) => {
  if (Modal && Modal.render && Modal.render.defaultProps) {
    Modal.render.defaultProps.setLoaderStatus(status);
  }
};
